import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalyticsService } from '@core/services/analytics/analytics.service';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptorService implements HttpInterceptor {
  projectId: string;
  sessionId: string;

  constructor(
    private readonly store: Store,
    private readonly analyticsService: AnalyticsService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(response => {
        if (response instanceof HttpResponse) {
          // Intercepted HttpsRequests here
          this.analyticsService.setErrorType('');
          this.analyticsService.setErrorMessage('');
        }
        catchError(err => {
          if (err.status) {
            // Update analytic (KO)
            this.analyticsService.setErrorType(err?.status.toString());
            this.analyticsService.setErrorMessage(err?.message);

            // Update activity registry (KO)
            // if (!isActivityRegistryRequest) {
            //   activityRegisterServicePayload = {
            //     ...activityRegisterServicePayload,
            //     serviceInfo: {
            //       ...activityRegisterServicePayload.serviceInfo,
            //       statusCode: err.status,
            //       isServiceResponseOK: err.ok,
            //       requestTime: new Date().getTime() - startingTime,
            //     },
            //   };
            //   return throwError(err);
            // }

            // For errors that are not Unauthorized (401)
            if (err.status !== HttpStatusCode.Unauthorized) {
              return throwError(err);
            }

            // // In case update session fails, init activity registry again
            // if (request.url.includes(ActivityRegistryService.UPDATE_SESSION_PATH)) {
            //   return this.activityRegistryService.getInit(this.projectId).pipe(
            //     switchMap(response => {
            //       this.store.dispatch(UpdateSessionId({ data: response.sessionId }));

            //       const that = this;
            //       const body = {
            //         ...request.body,
            //         sessionId: response.sessionId,
            //       } as Parameters<typeof that.activityRegistryService.postInsert>[number];

            //       return next.handle(
            //         request.clone({
            //           body,
            //           setHeaders: {
            //             ...request.headers,
            //             [HeadersEnum.X_SESSION_ID]: response.sessionId,
            //           },
            //         })
            //       );
            //     })
            //   );
            // } else {
            //   //  Inserting service returns 401 -> Update session
            //   return this.activityRegistryService.getUpdateSession(this.projectId, this.sessionId).pipe(
            //     switchMap(response => {
            //       this.store.dispatch(UpdateSessionId({ data: response.sessionId }));
            //       const that = this;
            //       const body = {
            //         ...request.body,
            //         sessionId: response.sessionId,
            //       } as Parameters<typeof that.activityRegistryService.postInsert>[number];
            //       return next.handle(
            //         request.clone({
            //           body,
            //           setHeaders: {
            //             ...request.headers,
            //             [HeadersEnum.X_SESSION_ID]: response.sessionId,
            //           },
            //         })
            //       );
            //     })
            //   );
            // }
          }
        });
      })
    );
  }
}
